import React from 'react';


// These are for the little sub tab components under the main WQ nad Hydrology selection
// Mainly to separate the Pollutant removal/Flow Reduction from the Performance Index tabs


export default function SubTab({ tabs, activeTab, onTabChange, children }) {
  return (
    <div className="mt-6">
      {/* Sub-tab headers */}
      <div className="flex gap-0.5 border-b justify-start mb-4 overflow-x-auto">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-1 sm:px-2 md:px-3 py-2 text-xs sm:text-sm font-medium border-b-2 rounded-t transition-colors min-h-[44px] flex-1 sm:flex-initial text-center leading-tight
              ${activeTab === tab.id
                ? "border-blue-500 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700"}`}
            style={{ maxWidth: tabs.length > 2 ? `${100 / tabs.length}%` : 'auto' }}
          >
            <span className="block break-words hyphens-auto">
              {tab.label}
            </span>
          </button>
        ))}
      </div>

      {/* Sub-tab content */}
      <div>
        {children}
      </div>
    </div>
  );
} 